import { render, staticRenderFns } from "./UpdateAdminRoleModal.vue?vue&type=template&id=19f4626c&scoped=true&"
import script from "./UpdateAdminRoleModal.vue?vue&type=script&lang=js&"
export * from "./UpdateAdminRoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f4626c",
  null
  
)

export default component.exports